module.exports = __webpack_public_path__ + "static/media/Artboard1.8ab1e49e.png";